import {
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';

import { HttpResponse } from '@angular/common/http';
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, catchError, of, throwError } from 'rxjs';
import { AccountPortalAuthService } from '../core/auth/auth.service';
import { environment } from '../environments/environment';
import { CathyService } from '../services/cathy.service';
import { Location } from '@angular/common';

/** Inject With Credentials into the request */
@Injectable()
export class PermissionsInterceptor implements HttpInterceptor {
  private route: ActivatedRoute;

  constructor(
    private _authService: AccountPortalAuthService,
    private _cathyService: CathyService,
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
    private _location: Location
  ) {
    this.route = this._activatedRoute;
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    return next.handle(request).pipe(catchError(err => {
      if (![401, 403].includes(err.status)) {
        const error = err.error?.message || err.statusText || 'Unknown error occurred';
        return throwError(() => error);
      }

      if ([401, 403].includes(err.status)) {
        const fullRedirectURL = window.location.href
        localStorage.setItem('redirectURL', fullRedirectURL);
        window.location.href = `/sign-in?nextURL=${encodeURIComponent(fullRedirectURL)}`
      }

      return of(err);
    }));
  }
}


